import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import parse from 'html-react-parser';
import { useMediaQuery,useTheme} from '@mui/material';

import '../css/MobileEmails.css'



const MobileEmails = ({ emails, placement }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if(emails && typeof emails !== 'undefined' && Array.isArray(emails) && emails.length > 0)
  return (
    <Box sx={{maxWidth: "98%"}}>
      <Stack spacing={2}>
        {emails.map((email) => {
          let emailbody = email.body_html??""
          try{
            emailbody = (emailbody??"").replaceAll("font-size: 9pt", "font-size: 7pt")
            emailbody = (emailbody??"").replaceAll("font-size: 10pt", "font-size: 8pt")
            emailbody = (emailbody??"").replaceAll("font-size:10pt", "font-size: 8pt")
            emailbody = (emailbody??"").replaceAll("font-size: 11pt", "font-size: 9pt")
            emailbody = (emailbody??"").replaceAll("font-size: 12pt", "font-size: 9pt")
            emailbody = (emailbody??"").replaceAll("font-size: 14pt", "font-size: 12pt")
          }catch(err) {
            emailbody = email.body_html??""
            console.log(err)
          }
          return (
          <Card key={email.email_id} variant="outlined">
            <CardContent>
              <div className="email-summary">
                <div><strong>From:</strong> {email.from}</div>
                <div><strong>To:</strong> {email.to?.join(', ')}</div>
                <div><strong>Cc:</strong> {email.cc.join(', ')}</div>
                {email.bcc?.length > 0 && <div><strong>Bcc:</strong> {email.bcc.join(', ')}</div>}
                <div><strong>Subject:</strong> {email.subject}</div>
                <div><strong>Date:</strong> {new Date(email.date_sent).toLocaleString()}</div>
              </div>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  View Email Body
                </AccordionSummary>
                <AccordionDetails>
                  <div style={{maxHeight: isMobile ? '300px': '100%', overflowY:'auto'}} >                  <div
                    className="email-body"
                    dangerouslySetInnerHTML={{ __html: emailbody || email.body_text || '' }}
                  />

              {email.replies?.length > 0 && (
                <Box mt={2}>
                  <Typography variant="subtitle2">Thread:</Typography>
                  <Stack spacing={1}>
                    {email.replies.map((reply) => {
                      let emailbody = reply.body_html??""
                      try {
                        emailbody = (emailbody??"").replaceAll("font-size: 9pt", "font-size: 7pt")
                        emailbody = (emailbody??"").replaceAll("font-size: 10pt", "font-size: 8pt")
                        emailbody = (emailbody??"").replaceAll("font-size:10pt", "font-size: 8pt")
                        emailbody = (emailbody??"").replaceAll("font-size: 11pt", "font-size: 8pt")
                        emailbody = (emailbody??"").replaceAll("font-size: 12pt", "font-size: 9pt")
                        emailbody = (emailbody??"").replaceAll("font-size: 14pt", "font-size: 12pt")
                      }catch(err) {
                        emailbody = email.body_html??""
                        console.log(err)
                      }
                      (
                        <>
                      <Card key={reply.email_id} variant="outlined" sx={{ ml: 2, marginBottom: "10px", maxWidth: "98%" }}>
                        <CardContent>
                          <div><strong>From:</strong> {reply.from}</div>
                          <div><strong>To:</strong> {reply.to?.join(', ')}</div>
                          <div><strong>Cc:</strong> {reply.cc?.join(', ')}</div>
                          <div><strong>Date:</strong> {new Date(reply.date_sent).toLocaleString()}</div>
                          {1==2 &&<div
                            dangerouslySetInnerHTML={{ __html: reply.body_html.replaceAll("font-size: 12pt", "font-size: 10pt") || reply.body_text || '' }}
                          />}
                          {parse(emailbody || reply.body_text || '' ) }
                        </CardContent>
                      </Card><br/>
                      <hr/>
                      </>
                    )})}
                  </Stack>
                </Box>
              )}
              </div>

                              </AccordionDetails>
              </Accordion>

            </CardContent>
          </Card>
        )})
      }
      </Stack>
    </Box>
  );
};

export default MobileEmails;
